import { Chip, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import { LOCALIZATION } from 'src/utils/constant';

const userStatuses = [
  {
    label: {
      en_US: 'Not ready',
      ru_RU: 'Заполните анкету',
    },
    value: 0,
    color: 'info',
  },
  {
    label: {
      en_US: 'For verification',
      ru_RU: 'На проверке',
    },
    value: 1,
    color: 'warning',
  },
  {
    label: {
      en_US: 'Accredited',
      ru_RU: 'Аккредитованы',
    },
    value: 2,
    color: 'success',
  },
  {
    label: {
      en_US: 'Rejected',
      ru_RU: 'Отклонено',
    },
    value: 3,
    color: 'error',
  },
];

export default function UserStatus({ userStatus, sx, icon, onClick, project, selfStatus }) {
  const lang = useSelector((state) => state.app.lang);
  const user = useSelector((state) => state.auth.user);
  const projectUuid = project.uuid;
  const myStatus = user?.projectSettings?.[projectUuid]?.userStatus;
  if (selfStatus === true) userStatus = myStatus;
  const isJoinedProject = user?.projectUuids?.includes(project);
  const label = userStatuses.find((el) => el.value === userStatus).label[lang];
  const color = userStatuses.find((el) => el.value === userStatus).color;
  return (
    <>
      <Tooltip title={isJoinedProject ? 'Перейти к анкете' : 'Сперва нажмите на " Добавить в мой список"'}>
        <Chip
          sx={{
            ...sx,
            '& .MuiChip-deleteIcon': {
              display: 'none',
              color: '#333',
            },
            '& .MuiChip-deleteIcon:hover': {
              color: '#333',
              display: 'none',
            },
          }}
          label={label}
          skin="light"
          color={color}
          onClick={onClick}
          onDelete={() => {}}
          // deleteIcon={icon}
        />
      </Tooltip>
    </>
  );
}
